<template>
  <div class="route-cost-page">
    <div class="page-header">
      <h1>Стоимость маршрута</h1>
      <div class="experimental-note">
        <span class="note-icon">⚠</span>
        <span>Страница экспериментальная. Данные берутся из ATI, цены могут отставать от реальных.</span>
      </div>
    </div>

    <div class="tab-bar">
      <button
        v-for="t in tabs"
        :key="t.key"
        :class="['tab-btn', { 'tab-active': activeTab === t.key }]"
        @click="selectTab(t.key)"
      >
        {{ t.label }}
      </button>
    </div>

    <div class="tab-content">
      <DirectionHero v-show="activeTab === 'overview'" />
      <RouteEnrichment v-if="mountedTabs.has('calc')" v-show="activeTab === 'calc'" />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DirectionHero from './price-check/DirectionHero.vue'
import RouteEnrichment from './RouteEnrichment.vue'

const TABS = [
  { key: 'overview', label: 'Обзор' },
  { key: 'calc', label: 'Массовый расчет' },
]

const VALID = new Set(TABS.map((t) => t.key))

export default {
  name: 'RouteCost',
  components: { DirectionHero, RouteEnrichment },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const activeTab = ref(VALID.has(route.query.tab) ? route.query.tab : 'overview')
    const mountedTabs = reactive(new Set(['overview']))

    const ensureMounted = (key) => {
      if (!mountedTabs.has(key)) mountedTabs.add(key)
    }

    const selectTab = (key) => {
      activeTab.value = key
      ensureMounted(key)
      const query = { ...route.query, tab: key }
      router.replace({ query })
    }

    watch(activeTab, (key) => ensureMounted(key))

    watch(() => route.query.tab, (tab) => {
      if (VALID.has(tab) && tab !== activeTab.value) {
        activeTab.value = tab
        ensureMounted(tab)
      }
    })

    onMounted(() => {
      ensureMounted(activeTab.value)
      if (!route.query.tab) {
        router.replace({ query: { ...route.query, tab: activeTab.value } })
      }
    })

    return { tabs: TABS, activeTab, mountedTabs, selectTab }
  },
}
</script>

<style scoped>
.route-cost-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: calc(100vh - 60px);
}

.page-header {
  margin-bottom: 18px;
}

.page-header h1 {
  margin: 0;
  color: #1d2b44;
  font-size: 26px;
}

.experimental-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 14px;
  line-height: 1.45;
}

.note-icon {
  flex-shrink: 0;
  color: #ea580c;
  font-size: 16px;
}

.tab-bar {
  display: flex;
  gap: 6px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e1e8f1;
  flex-wrap: wrap;
}

.tab-btn {
  padding: 11px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #56657a;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
}

.tab-btn:hover {
  color: #1d2b44;
}

.tab-active {
  color: #3f6fb5;
  border-bottom-color: #3f6fb5;
}

.tab-content {
  min-height: 200px;
}
</style>
